<div class="dialog-content">
  <div class="close-button">
    <img src="assets/cross.svg" alt="Cerrar" (click)="close()" />
  </div>
  <div class="dialog-title">
    <img
      src="assets/editar-borde.svg"
      alt="Agregar"
      class="dialog-title-icon"
    />
    <span class="dialog-title-text">Gestionar Campos</span>
  </div>
  <div class="dialog-subtitle">DETALLE</div>
  <div class="input-container">
    <div class="input-title">CATEGORIA</div>
    <div class="disabled-input">{{ data.openedCategoriaKey }}</div>
  </div>
  <div class="input-container">
    <div class="input-title">SUBCATEGORIA</div>
    <div class="disabled-input">{{ data.editingSubcategoria.key }}</div>
  </div>
  @if (selectedFieldLabel) {
    <div class="input-container">
      <div class="input-title">CAMPO</div>
      <div class="disabled-input">{{ selectedFieldLabel }}</div>
    </div>
  }
  <div class="dialog-subtitle dialog-subtitle--margin-top">CAMPOS</div>
  @if (!selectedFieldLabel) {
    <table class="collapsed-header-table mantenedor-dialog-table">
      <caption>
        Tabla Modal
      </caption>
      <thead>
        <tr>
          <th scope="col">Campos</th>
          <th scope="col"><div class="width-110">Ordenar / Acción</div></th>
        </tr>
        <tr class="separator-row">
          <th scope="col" colspan="100%"></th>
        </tr>
      </thead>
      <tbody>
        @for (
          field of sortedFields;
          track field.label;
          let i = $index;
          let count = $count
        ) {
          <tr>
            <td>
              <div class="width-160-ellipsis">{{ field.label }}</div>
            </td>
            <td>
              @if (count > 1) {
                <span class="dialog-actions">
                  @if (i < count - 1) {
                    <img
                      src="assets/flecha-abajo.svg"
                      alt="bajar"
                      class="dialog-action-icon dialog-action-icon--spaced"
                      (click)="moveDown(i)"
                    />
                  }
                  @if (i > 0) {
                    <img
                      src="assets/flecha-arriba.svg"
                      alt="subir"
                      class="dialog-action-icon dialog-action-icon--spaced"
                      (click)="moveUp(i)"
                    />
                  }
                </span>
              }
              <img
                src="assets/edit.svg"
                alt="editar"
                class="dialog-action-icon dialog-action-icon--edit"
                (click)="onClickEditField(field)"
              />
            </td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <table
      class="collapsed-header-table mantenedor-dialog-table subcampos-table"
    >
      <caption>
        Tabla Modal
      </caption>
      <colgroup>
        <col style="width: 270px" />
        <col />
        <col />
      </colgroup>
      <thead>
        <tr>
          <th scope="col">Desencadenante</th>
          <th scope="col">Subcampo</th>
          <th scope="col">Acción</th>
        </tr>
        <tr class="separator-row">
          <th scope="col" colspan="100%"></th>
        </tr>
      </thead>
      <tbody>
        @if (selectedField && selectedField.desencadenante) {
          <tr>
            <td>
              <div class="ellipsis-text" dialogEllipsisTooltip>
                {{ selectedField.desencadenante }}
              </div>
            </td>
            <td>
              <div class="ellipsis-text" dialogEllipsisTooltip>
                {{ selectedField.subcampo }}
              </div>
            </td>
            <td class="center">
              <img
                src="assets/trash.svg"
                alt="Eliminar"
                (click)="onDeleteRelation()"
              />
            </td>
          </tr>
        } @else {
          <tr>
            <td colspan="3">No hay subcampos asignados a este campo</td>
          </tr>
        }
      </tbody>
    </table>

    @if (isSelectedFieldPicklist && otherFields.length > 0) {
      <div class="input-container">
        <div class="input-title">DESENCADENANTE SUBCAMPO</div>
        <ng-select
          [items]="selectedField?.picklist_values || []"
          [(ngModel)]="selectedTriggerValue"
          [clearable]="false"
          [searchable]="false"
          [closeOnSelect]="false"
          [hideSelected]="true"
          [multiple]="true"
          dropdownPosition="bottom"
          placeholder="Seleccionar"
        ></ng-select>
      </div>
      <div class="input-container lower-z-index-select">
        <div class="input-title">SUBCAMPO</div>
        <ng-select
          [items]="otherFields"
          bindLabel="label"
          bindValue="label"
          [(ngModel)]="selectedSubcampoKey"
          [clearable]="false"
          [searchable]="false"
          dropdownPosition="bottom"
          placeholder="Seleccionar"
        ></ng-select>
      </div>
    }
  }

  <hr />
  <div class="dialog-action-buttons">
    <button [disabled]="!canSaveChanges" (click)="onSave()">
      Guardar Cambios
    </button>
    <button class="red-button" (click)="onCancel()">Cancelar</button>
  </div>
</div>
